var map = {
	"./accessories.png": "./src/assets/icons/accessories.png",
	"./automation.png": "./src/assets/icons/automation.png",
	"./contacts.png": "./src/assets/icons/contacts.png",
	"./dashboard.png": "./src/assets/icons/dashboard.png",
	"./devices.png": "./src/assets/icons/devices.png",
	"./driver.png": "./src/assets/icons/driver.png",
	"./export.png": "./src/assets/icons/export.png",
	"./general-settings.png": "./src/assets/icons/general-settings.png",
	"./import-export.png": "./src/assets/icons/import-export.png",
	"./import.png": "./src/assets/icons/import.png",
	"./intercom-contacts.png": "./src/assets/icons/intercom-contacts.png",
	"./intercom-settings.png": "./src/assets/icons/intercom-settings.png",
	"./intercom.png": "./src/assets/icons/intercom.png",
	"./ip-cameras.png": "./src/assets/icons/ip-cameras.png",
	"./menu-items.png": "./src/assets/icons/menu-items.png",
	"./network-settings.png": "./src/assets/icons/network-settings.png",
	"./panel-settings.png": "./src/assets/icons/panel-settings.png",
	"./rooms.png": "./src/assets/icons/rooms.png",
	"./rss-settings.png": "./src/assets/icons/rss-settings.png",
	"./scenes.png": "./src/assets/icons/scenes.png",
	"./security-settings.png": "./src/assets/icons/security-settings.png",
	"./security.png": "./src/assets/icons/security.png",
	"./system-settings.png": "./src/assets/icons/system-settings.png",
	"./triggers.png": "./src/assets/icons/triggers.png",
	"./ui-settings.png": "./src/assets/icons/ui-settings.png",
	"./widgets.png": "./src/assets/icons/widgets.png"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/assets/icons sync recursive ^\\.\\/.*$";